import axios from 'axios';
import {
    ADD_PROCESS_FAIL,
    ADD_PROCESS_REQUEST,
    ADD_PROCESS_SUCCESS,
    GET_PROCESSES_FAIL,
    GET_PROCESSES_REQUEST,
    GET_PROCESSES_SUCCESS,
    UPDATE_PROCESS_FAIL,
    UPDATE_PROCESS_REQUEST,
    UPDATE_PROCESS_SUCCESS,
    DELETE_PROCESS_FAIL,
    DELETE_PROCESS_REQUEST,
    DELETE_PROCESS_SUCCESS,
} from '../constants/processConstants';

const baseUrl = process.env.REACT_APP_API_URL;

export const addProcess = (process, processType) => async (dispatch, getState) => {
    try {
        dispatch({
            type: ADD_PROCESS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/processes/add-process`,
            { process, processType },
            config
        );

        dispatch({
            type: ADD_PROCESS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: ADD_PROCESS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getProcesses = (page = 1, limit = 10, search = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_PROCESSES_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/processes?page=${page}&limit=${limit}&search=${search}`,
            config
        );

        dispatch({
            type: GET_PROCESSES_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_PROCESSES_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const updateProcess = (id, process) => async (dispatch, getState) => {
    try {
        dispatch({
            type: UPDATE_PROCESS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.put(
            `${baseUrl}/processes/${id}`,
            { process },
            config
        );

        dispatch({
            type: UPDATE_PROCESS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: UPDATE_PROCESS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteProcess = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: DELETE_PROCESS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.delete(`${baseUrl}/processes/${id}`, config);

        dispatch({
            type: DELETE_PROCESS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: DELETE_PROCESS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};